import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

interface AnimationTarget {
  current: HTMLElement | null;
}

/**
 * Animates the video container with a slide-in from left effect
 * @param videoContainerRef - Reference to the video container element
 * @param sectionRef - Reference to the section element (for scroll triggering)
 */
export const animateVideoContainer = (
  videoContainerRef: AnimationTarget,
  sectionRef: AnimationTarget
) => {
  if (!videoContainerRef.current || !sectionRef.current) return;

  // Set initial state
  gsap.set(videoContainerRef.current, {
    x: -50,
    opacity: 0,
  });

  // Create animation
  gsap.to(videoContainerRef.current, {
    x: 0,
    opacity: 1,
    duration: 0.8,
    ease: "power3.out",
    scrollTrigger: {
      trigger: sectionRef.current,
      start: "top 70%",
      once: true,
    },
  });
};

/**
 * Animates the content section with a slide-in from right effect
 * @param contentRef - Reference to the content container element
 * @param sectionRef - Reference to the section element (for scroll triggering)
 * @param delay - Optional delay before animation starts
 */
export const animateContent = (
  contentRef: AnimationTarget,
  sectionRef: AnimationTarget,
  delay: number = 0.2
) => {
  if (!contentRef.current || !sectionRef.current) return;

  // Set initial state
  gsap.set(contentRef.current, {
    x: 50,
    opacity: 0,
  });

  // Create animation
  gsap.to(contentRef.current, {
    x: 0,
    opacity: 1,
    duration: 0.8,
    delay: delay,
    ease: "power3.out",
    scrollTrigger: {
      trigger: sectionRef.current,
      start: "top 70%",
      once: true,
    },
  });
};

/**
 * Cleans up all ScrollTrigger instances
 */
export const cleanupScrollTriggers = () => {
  ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
};
